import { __ } from '../../../translations';
import { Modal } from '../../../components/ui/Modal';
import { PurchaseModal, PurchaseCCForm } from './elements';
import { PPVDetailContent } from './PPVDetailsContent';
import { usePPVActions } from '../hooks/usePPVAction';

const PPVDetailModal = () => {
    const {
        selectedPPVId,
        selectedPPVEvent,
        selectedProgram,
        selectedChannel,
        ppvSubscribedList,
        formRef,
        showppvPurchaseOverlay,
        showppvQrModal,
        setShowppvPurchaseOverlay,
        setShowppvQrModal,
        handleCloseOverlay,
        handleClickPlay,
        handleClickPurchase,
        onPurchaseSuccess,
    } = usePPVActions();

    return selectedPPVEvent ? (
        <Modal useFlexLayout={false} open={selectedPPVId !== null} onOpenChange={handleCloseOverlay}>
            <PPVDetailContent
                selectedPPVEvent={selectedPPVEvent}
                selectedProgram={selectedProgram}
                ppvSubscribedList={ppvSubscribedList}
                handleClickPurchase={handleClickPurchase}
                handleClickPlay={handleClickPlay}
                selectedChannel={selectedChannel}
            />
            <PurchaseCCForm formRef={formRef} selectedPPVEvent={selectedPPVEvent} />
            <PurchaseModal
                showppvPurchaseOverlay={showppvPurchaseOverlay}
                setShowppvPurchaseOverlay={setShowppvPurchaseOverlay}
                selectedPPVEvent={selectedPPVEvent}
                onPurchaseSuccess={onPurchaseSuccess}
                showppvQrModal={showppvQrModal}
                setShowppvQrModal={setShowppvQrModal}
            />
        </Modal>
    ) : null;
};

export default PPVDetailModal;
